export default "__VITE_ASSET__dpifECS3__"